/**
 * Created by pandemio on 9/23/18.
 */
import React from 'react';
import { Button, Table, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import ApiCalls from '../../custom-classes/api-calls';
import {Link} from "react-router-dom";

/**
 * Class that handles the modal ters
 */
class TableSubscriptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            modal: false,
            subscriptionId: null

        };

        this.toggle = this.toggle.bind(this);
        this.redirectToProfileManagement = this.redirectToProfileManagement.bind(this);
    }

    /**
     * Hide or shows the message window
     */
    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    redirectToProfileManagement(e){

        this.setState({
            subscriptionId: e.target.value
        });
    }

    /**
     * Set the state data
     */
    componentWillMount(){

        let subscriptions = []; // The subscriptions options to add

        // Call the subscriptions
        let apiCall = ApiCalls.getUserSubscriptions();
        apiCall.then((dataReturned)=>{
            // If the transaction is valid, then evaluate
            if(dataReturned.TransactionValid)
            {
                let subscriptionsDB = dataReturned.Subscriptions;

                for(let i=0; i < subscriptionsDB.length;i++)
                {
                    let row;
                    let intervalTranslateId = "subscriptions." +subscriptionsDB[i].Plan.Interval;
                    let statePlanTranslatedId = "subscriptions." + subscriptionsDB[i].Status;
                    // If the status of the subscriptions is not active or is not trialing, do not show the cancel
                    // button. Else, show the cancel button
                    if(subscriptionsDB[i].Status !== 'active' && subscriptionsDB[i].Status !== 'trialing')
                    {
                        row = <tr key={subscriptionsDB[i].SubscriptionId}>
                            <td>{'ORD' + subscriptionsDB[i].SubscriptionId}</td>
                            <td>{subscriptionsDB[i].Plan.PlanDescriptionByLang[0].Name}</td>
                            <td><Translate id={intervalTranslateId}/></td>
                            <td>{subscriptionsDB[i].ProfilesTotalQuantity}</td>
                            <td><Translate id={statePlanTranslatedId}/></td>
                            <td></td>
                            <td></td>
                        </tr>;
                    }
                    else
                    {
                        row = <tr key={subscriptionsDB[i].SubscriptionId}>
                            <td>{'ORD' + subscriptionsDB[i].SubscriptionId}</td>
                            <td>{subscriptionsDB[i].Plan.PlanDescriptionByLang[0].Name}</td>
                            <td><Translate id={intervalTranslateId}/></td>
                            <td>{subscriptionsDB[i].ProfilesTotalQuantity}</td>
                            <td><Translate id={statePlanTranslatedId}/></td>
                            <td>
                                <Button className="btn-info" onClick={this.toggle}>
                                    <Translate id="subscriptions.cancel" options={{renderInnerHtml: false}}/>
                                </Button>
                            </td>
                            <td>
                                <Link className="btn btn-warning"  to={{
                                pathname: "/add-child-profile",
                                subscriptionId: subscriptionsDB[i].SubscriptionId
                                }}>  <Translate id="subscriptions.manage-profiles"/>
                                </Link>
                            </td>
                        </tr>;
                    }

                    subscriptions.push(row);
                }
            }
            return subscriptions;
        }).then((subscriptions)=>{
            this.setState({rows: subscriptions});
        });
    }

    render() {

        if(this.state.subscriptionId !== null && this.state.subscriptionId !== '')
        {
            return (<Link  to={{
                pathname: "/add-child-profile",
                subscriptionId: this.state.subscriptionId
            }}/>);
        }

        return (
            <div>
                <Table className="card-white" responsive>
                    <thead>
                    <tr>
                        <th><Translate id="subscriptions.ref" options={{renderInnerHtml: false}}/></th>
                        <th><Translate id="subscriptions.plan" options={{renderInnerHtml: false}}/></th>
                        <th><Translate id="subscriptions.interval" options={{renderInnerHtml: false}}/></th>
                        <th><Translate id="subscriptions.profiles-included" options={{renderInnerHtml: false}}/></th>
                        <th><Translate id="subscriptions.status" options={{renderInnerHtml: false}}/></th>
                        <th><Translate id="subscriptions.cancel" options={{renderInnerHtml: false}}/></th>
                        <th><Translate id="subscriptions.manage-profiles" options={{renderInnerHtml: false}}/></th>
                    </tr>
                    </thead>
                    <tbody>
                        { this.state.rows !== "0" ? this.state.rows : null }
                    </tbody>
                </Table>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader className="card-red" toggle={this.toggle}>
                        <Translate id="subscriptions.cancel-title" options={{renderInnerHtml: false}}/>
                    </ModalHeader>
                    <ModalBody className="card-red">
                        <Translate id="subscriptions.cancel-details" options={{renderInnerHtml: false}}/>
                    </ModalBody>
                    <ModalFooter className="card-red">
                        <Button onClick={this.toggle} color="info">
                            <Translate id="subscriptions.close" options={{renderInnerHtml: false}}/>
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
export default TableSubscriptions;